import React, { CSSProperties, ReactNode } from 'react';

import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import CustomIcon from '@components/utils/CustomIcon';

import {
  ResponsiveSearchDrawerItemContent,
  ResponsiveSearchDrawerItemText,
} from '../ResponsiveListingSearchStyle';

type CustomIconProps = React.ComponentType<
  React.SVGProps<SVGSVGElement> | CustomIconComponentProps
>;
export interface ResponsiveDrawerInterface {
  icon?:
    | React.FunctionComponent<
        React.SVGProps<SVGSVGElement> | CustomIconComponentProps
      >
    | React.ComponentClass<
        React.SVGProps<SVGSVGElement> | CustomIconComponentProps,
        any
      >
    | undefined;

  title?: string;
  subTitle?: string | ReactNode;
  arrowIcon?: boolean;
  onClick?:
    | ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void)
    | undefined;

  className?: string;
  placeholder?: string;
  arrowIconType?: CustomIconProps;
  startDate?: moment.Moment | null;
  endDate?: moment.Moment | null;
  error?: boolean;
  height?: CSSProperties['height'];
  onFocusChange?: (input: 'startDate' | 'endDate') => void;
  showLabel?: boolean;
}

const ResponsiveSearchDrawerItem: React.FC<ResponsiveDrawerInterface> = ({
  icon,
  subTitle,
  onClick = () => false,
  className,
  placeholder,
  error,
  height,
}) => {
  return (
    <ResponsiveSearchDrawerItemContent
      role='button'
      tabIndex={-1}
      onClick={onClick}
      className={className}
      hasError={error || false}
      height={height}
    >
      <CustomIcon icon={icon} fontSize={20} paletteColor='grey500' />

      <ResponsiveSearchDrawerItemText isEmpty={!subTitle}>
        {subTitle || placeholder}
      </ResponsiveSearchDrawerItemText>
    </ResponsiveSearchDrawerItemContent>
  );
};

export default ResponsiveSearchDrawerItem;
